import { AxiosResponse } from "axios";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { Result } from "@/main/models/common/resultResponse";
import {
	TemplateEmailNotificationHistoricalSearchGridRequest,
	TemplateEmailNotificationHistoricalDetailRequest,
} from "@/main/models/request/templateEmailNotificationRequest";
import {
	TemplateEmailNotificationHistoricalGridResponse,
	TemplateEmailNotificationHistoricalDetailResponse,
} from "@/main/models/response/templateEmailNotificationResponse";

export abstract class ITemplateEmailNotificationHistoricalApi {
	abstract searchGridHistorical(
		request: TemplateEmailNotificationHistoricalSearchGridRequest,
	): Promise<AxiosResponse<PaginationResponse<TemplateEmailNotificationHistoricalGridResponse>>>;
	abstract getDetailHistorical(
		request: TemplateEmailNotificationHistoricalDetailRequest,
	): Promise<AxiosResponse<Result<TemplateEmailNotificationHistoricalDetailResponse>>>;
}
